import { useEffect, useState } from 'react'
import { CloudUpload, TriangleAlert } from 'lucide-react'
import { carreteiroProprioEndpoints, type FichaPropriaNoServidor } from '@/core/api/endpoints'
import { dataBR } from './carreteiroRegras'

/**
 * Fichas de FROTA PRÓPRIA que já saíram do aparelho mas ainda não entraram no
 * SIGA: o servidor guarda até existir a linha da Parte Diária daquele caminhão
 * naquele dia e anexa sozinho (ver backend/src/carreteiro/proprio.ts).
 *
 * Só aparece online — é um retrato do servidor, não um dado local.
 */
export function FichasPropriasNoServidor() {
  const [dados, setDados] = useState<{ pendentes: FichaPropriaNoServidor[]; recusadas: FichaPropriaNoServidor[] } | null>(null)

  useEffect(() => {
    let cancelado = false
    carreteiroProprioEndpoints
      .pendentes()
      .then((d) => {
        if (!cancelado) setDados(d)
      })
      .catch(() => {
        /* offline ou sem acesso: a seção simplesmente não aparece */
      })
    return () => {
      cancelado = true
    }
  }, [])

  if (!dados || (dados.pendentes.length === 0 && dados.recusadas.length === 0)) return null

  return (
    <section className="space-y-2">
      {dados.pendentes.length > 0 && (
        <>
          <h2 className="text-xs font-bold text-info uppercase px-1">
            Frota própria · no servidor, aguardando a parte diária ({dados.pendentes.length})
          </h2>
          {dados.pendentes.map((f) => (
            <div key={f.id} className="card-surface-variant px-4 py-3 flex items-start gap-3">
              <CloudUpload className="h-5 w-5 text-info shrink-0 mt-0.5" aria-hidden />
              <div className="min-w-0">
                <p className="text-sm text-on-surface font-medium">
                  {f.ficha ? `Ficha nº ${f.ficha} · ` : ''}{dataBR(f.dtMovimentacao)} · {f.viagens} viagem(ns)
                </p>
                <p className="text-xs text-on-surface-dim mt-0.5">{f.motivo ?? 'Aguardando a parte diária do dia.'}</p>
              </div>
            </div>
          ))}
          <p className="text-xs text-on-surface-dim px-1">
            Nada a fazer aqui: as viagens entram sozinhas no SIGA quando a parte diária do caminhão for lançada (o número da ficha sai nessa hora).
          </p>
        </>
      )}
      {dados.recusadas.length > 0 && (
        <>
          <h2 className="text-xs font-bold text-bad uppercase px-1 pt-2">
            Frota própria · o servidor não conseguiu gravar ({dados.recusadas.length})
          </h2>
          {dados.recusadas.map((f) => (
            <div key={f.id} className="card-surface-variant px-4 py-3 flex items-start gap-3 border border-bad/30">
              <TriangleAlert className="h-5 w-5 text-bad shrink-0 mt-0.5" aria-hidden />
              <div className="min-w-0">
                <p className="text-sm text-on-surface font-medium">
                  {f.ficha ? `Ficha nº ${f.ficha} · ` : ''}{dataBR(f.dtMovimentacao)} · {f.viagens} viagem(ns)
                </p>
                <p className="text-xs text-bad mt-0.5">{f.resultado ?? f.motivo ?? 'Recusada pelo servidor.'}</p>
              </div>
            </div>
          ))}
          <p className="text-xs text-on-surface-dim px-1">Essas viagens precisam ser lançadas de novo (ou direto no SIGA).</p>
        </>
      )}
    </section>
  )
}
